import { inject, Injectable } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { isUndefined } from 'lodash-es';
import { DateTime } from 'luxon';

import { DatePickerModalComponent } from '../components/date-picker-modal/date-picker-modal.component';

@Injectable({
  providedIn: 'root'
})
export class DatePickerService {
  private modalController = inject(ModalController);

  async open(
    value: string | null,
    options?: {
      max?: string;
      min?: string;
    }
  ) {
    const modal = await this.modalController.create({
      component: DatePickerModalComponent,
      componentProps: {
        ...(!isUndefined(options) && options),
        value: value ? DateTime.fromFormat(value, 'MM/dd/yyyy').toISODate() : ''
      }
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();

    return data?.date ? DateTime.fromISO(data.date).toFormat('MM/dd/yyyy') : null;
  }
}
